import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {COIService} from '../coi.service';
import {User} from '../../models/users';

@Injectable()
export class UserService extends COIService {

  getUser(userId: string): Observable<User> {
    return this.httpGet(`/user/${userId}`);
  }

  verify(type: string, token: string): Observable<{ message: string }> {
    return this.httpPost(`/users/verify/${type}/${token}`);
  }

  sendVerificationEmail(userId: number): Observable<{ message: string }>  {
    return this.httpPost(`/users/send_user_verification_email/${userId}`);
  }
}
